"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var GoogleIcon = function GoogleIcon(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: props.style
  }, props.disabled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.99996 3.5625C10.3275 3.5625 11.5162 4.02 12.4537 4.9125L15.0225 2.34375C13.4625 0.8925 11.4262 0 8.99996 0C5.48246 0 2.44121 2.0175 0.959961 4.9575L3.95246 7.27875C4.66121 5.145 6.65246 3.5625 8.99996 3.5625Z",
    fill: "#C0C5D1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.6175 9.20625C17.6175 8.6175 17.5612 8.0475 17.475 7.5H9V10.8825H13.8525C13.635 11.9925 13.005 12.9375 12.06 13.575L14.9588 15.825C16.65 14.2575 17.6175 11.94 17.6175 9.20625Z",
    fill: "#C0C5D1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.94875 10.7213C3.76875 10.1775 3.66375 9.60002 3.66375 9.00002C3.66375 8.40002 3.765 7.82252 3.94875 7.27877L0.95625 4.95752C0.345 6.17252 0 7.54502 0 9.00002C0 10.455 0.345 11.8275 0.96 13.0425L3.94875 10.7213Z",
    fill: "#C0C5D1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.00005 18C11.43 18 13.4738 17.2013 14.9588 15.8213L12.06 13.5713C11.2538 14.115 10.215 14.4338 9.00005 14.4338C6.65255 14.4338 4.6613 12.8513 3.9488 10.7175L0.956299 13.0388C2.4413 15.9825 5.48255 18 9.00005 18Z",
    fill: "#C0C5D1"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "18",
    height: "18",
    fill: "white"
  })))) : /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.99999 3.5625C10.3275 3.5625 11.5162 4.02 12.4537 4.9125L15.0225 2.34375C13.4625 0.8925 11.4262 0 8.99999 0C5.48249 0 2.44124 2.0175 0.959991 4.9575L3.95249 7.27875C4.66124 5.145 6.65249 3.5625 8.99999 3.5625Z",
    fill: "#EA4335"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.6175 9.20625C17.6175 8.6175 17.5612 8.0475 17.475 7.5H9V10.8825H13.8525C13.635 11.9925 13.005 12.9375 12.06 13.575L14.9588 15.825C16.65 14.2575 17.6175 11.94 17.6175 9.20625Z",
    fill: "#4285F4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.94875 10.7213C3.76875 10.1775 3.66375 9.60002 3.66375 9.00002C3.66375 8.40002 3.765 7.82252 3.94875 7.27877L0.95625 4.95752C0.345 6.17252 0 7.54502 0 9.00002C0 10.455 0.345 11.8275 0.96 13.0425L3.94875 10.7213Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 18C11.43 18 13.4738 17.2013 14.9588 15.8213L12.06 13.5713C11.2538 14.115 10.215 14.4338 9 14.4338C6.6525 14.4338 4.66125 12.8513 3.94875 10.7175L0.956253 13.0388C2.44125 15.9825 5.4825 18 9 18Z",
    fill: "#34A853"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "18",
    height: "18",
    fill: "white"
  })))));
};
/*---------------------------------------------*/


var SocialButton = /*#__PURE__*/function (_Component) {
  _inherits(SocialButton, _Component);

  var _super = _createSuper(SocialButton);

  function SocialButton() {
    var _this;

    _classCallCheck(this, SocialButton);

    _this = _super.call(this);
    _this.state = {};
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SocialButton, [{
    key: "onClick",
    value: function onClick(e) {}
  }, {
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var style = {
        googleButton: {
          color: this.props.disabled ? "var(--color-neutral-400)" : "var(--color-neutral-700)"
        },
        googleButtonIcon: {
          display: "inline-block",
          lineHeight: 0,
          marginTop: 3,
          marginRight: 11,
          verticalAlign: "top"
        }
      };

      var props = _objectSpread(_objectSpread({}, this.props), {}, {
        variant: "flat",
        style: style.googleButton
      });

      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames(),
        style: this.getStyle()
      }, /*#__PURE__*/_react.default.createElement(_.Button, props, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          paddingLeft: "var(--space-inline-s)",
          paddingRight: "var(--space-inline-s)"
        }
      }, /*#__PURE__*/_react.default.createElement(GoogleIcon, {
        disabled: this.props.disabled,
        style: style.googleButtonIcon
      }), this.props.children || this.props.text || "Connect to Google")));
    }
  }]);

  return SocialButton;
}(_component.default);
/*---------------------------------------------*/


exports.default = SocialButton;

_defineProperty(SocialButton, "BASE_CLASS", "lth-c-socialbutton");

SocialButton.METADATA = {
  name: "Socialbutton",
  props: [// {
  // 	name: 'size',
  // 	type: 'string',
  // 	default: 'regular',
  // 	description: 'Choose the size of button',
  // 	options: [
  // 		{
  // 			value: 'slim',
  // 			description: 'Slim sized button.'
  // 		},
  // 		{
  // 			value: 'regular',
  // 			description: 'Regular sized button.'
  // 		},
  // 		{
  // 			value: 'super',
  // 			description: 'Super-sized button.'
  // 		}
  // 	]
  // },
  {
    name: "disabled",
    type: "boolean",
    default: false,
    description: "Show the component in disabled state."
  }, {
    name: "forcehover",
    type: "boolean",
    default: false,
    description: "Force hover state."
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false,
    description: "Force focus state."
  }, {
    name: "onClick",
    type: "function",
    description: "Callback function called after the button is clicked"
  }]
};